export default "__VITE_ASSET__Y4CJ09vH__"